var Diplome = /** @class */ (function () {
    function Diplome() {
    }
    return Diplome;
}());
export { Diplome };
